import { render, staticRenderFns } from "./SurgeryRecords.vue?vue&type=template&id=a2a9d32e&scoped=true&"
import script from "./SurgeryRecords.vue?vue&type=script&lang=js&"
export * from "./SurgeryRecords.vue?vue&type=script&lang=js&"
import style0 from "./SurgeryRecords.vue?vue&type=style&index=0&id=a2a9d32e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a9d32e",
  null
  
)

export default component.exports